import React, { useEffect, useState } from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { PrimaryButton, Text, Colors } from 'library';
import { useUserContext } from 'UserContext';
import ReferralActions from './referrals/ReferralActions';
import GroupListingPage from './groups/GroupListingPage/GroupListingPage';
import { isMobile } from 'react-device-detect';
import { client, consoleLogInDev } from 'shared';
import CommunityRepresentativeCard from './CommunityRepresentativeCard';
import theme from 'theme';
import OneTimeGiftCard from './referrals/OneTimeGiftCardModal';
import { track } from 'shared';
import { FamilyUserAttributes } from 'parent-portal/shared/UserAttributes';
import userAttributesApi from 'shared/UserAttributesApi';
import useTrackingCookies from 'parent-portal/shared/EngagementSourceTracking';
import usePublicSessionTracking from 'parent-portal/shared/PublicSessionTracking';

const background = require('assets/gradients/community-gradient.svg');
const PIC = require('assets/images/cbus-shutterstock_703830412.jpg');

const styles = {
    background: {
        backgroundImage: `url(${background})`,
        paddingBottom: '10vh',
        backgroundPosition: 'center',
        minHeight: '100vh',
        filter: `blur(25px)`,
        zIndex: -1,
    },
};
export interface StatsModel {
    number_sent: number;
    number_joined: number;
}

const GIFT_CARD_MODAL_STEPS = {
    initial: 'initial',
    success: 'success',
};

const Community = () => {
    const history = useHistory();
    const { user } = useUserContext();
    const [refContext, setRefContext] = useState<string>('Referrals');
    const [referralStats, setReferralStats] = useState<StatsModel>();
    const [openGiftCardModal, setOpenGiftCardModel] = useState(false);
    const [showGiftCardButton, setShowGiftCardButton] = useState(false);
    const [modalStep, setPromoStep] = useState(GIFT_CARD_MODAL_STEPS.initial);
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    const { usePageLoadTracking } = usePublicSessionTracking('Referrals');

    useTrackingCookies('/referrals');
    usePageLoadTracking();

    useEffect(() => {
        const state = history?.location?.state as { referralContext?: string };
        if (state?.referralContext) {
            setRefContext(state.referralContext);
        }
        client(`tracking/api/referral/stats`).then(setReferralStats);
        getOneTimeGiftCardStatus();
    }, []);

    function getOneTimeGiftCardStatus() {
        userAttributesApi
            .exists(FamilyUserAttributes.OneTimeGiftCardSeen)
            .then((response: boolean) => {
                if (!response) {
                    onGiftCardModalOpen(true);
                }
            })
            .catch(consoleLogInDev);

        userAttributesApi
            .exists(FamilyUserAttributes.OneTimeGiftCardSent)
            .then((response: boolean) => {
                if (response) {
                    setPromoStep(GIFT_CARD_MODAL_STEPS.success);
                } else {
                    setShowGiftCardButton(true);
                }
            })
            .catch(consoleLogInDev);
    }

    function onGiftCardModalOpen(auto: boolean) {
        setOpenGiftCardModel(true);
        userAttributesApi.create(FamilyUserAttributes.OneTimeGiftCardSeen).catch(consoleLogInDev);
        track('Community: Send a $40 Gift Card modal opened', { auto: auto });
    }

    function onClose() {
        setOpenGiftCardModel(false);
        track('Community: Send a $40 Gift Card Modal closed');
    }

    return (
        <Grid container direction="row">
            <img
                src={PIC}
                alt={'profile1'}
                style={{
                    marginTop: -30,
                    width: '100%',
                    maxHeight: '35vh',
                    objectFit: 'cover',
                    objectPosition: '30% 52%',
                }}
            />
            <Grid
                container
                item
                style={{
                    top: '30%',
                    position: 'absolute',
                    ...styles.background,
                }}
            ></Grid>
            <Grid container item xs={12} spacing={3} style={{ padding: 10, margin: isMobile ? 8 : 40 }}>
                <Grid item>
                    <Text variant="display" textStyle={{ fontSize: isMobile ? 24 : 36 }}>
                        Grow your Tandem community{!!user ? `, ${user.first_name}` : ''}!
                    </Text>
                </Grid>
                {!!showGiftCardButton ? (
                    <Grid item>
                        <PrimaryButton
                            onClick={() => onGiftCardModalOpen(false)}
                            buttonStyle={{ height: 45, backgroundColor: Colors.mediumRed }}
                        >
                            Send a $40 gift card for free
                        </PrimaryButton>
                    </Grid>
                ) : null}
            </Grid>
            {mdDown ? (
                <Grid container item style={{ padding: 25 }}>
                    <Grid item>
                        {!!referralStats ? (
                            <ReferralActions referralContext={refContext} referralStats={referralStats} />
                        ) : null}
                    </Grid>
                    <Grid item style={{ marginTop: 15, overflowX: 'hidden', position: 'relative' }}>
                        <GroupListingPage />
                    </Grid>
                    <CommunityRepresentativeCard />
                </Grid>
            ) : (
                <>
                    <Grid item md={12} lg={6} style={{ padding: 10 }}>
                        <CommunityRepresentativeCard />
                        {!!referralStats ? (
                            <ReferralActions referralContext={refContext} referralStats={referralStats} />
                        ) : null}
                    </Grid>
                    <Grid item md={12} lg={6} style={{ padding: 10, overflowX: 'hidden', position: 'relative' }}>
                        <GroupListingPage />
                    </Grid>
                </>
            )}
            <OneTimeGiftCard
                open={openGiftCardModal}
                referralContext={refContext}
                onClose={onClose}
                promoStep={modalStep}
                setPromoStep={setPromoStep}
            />
        </Grid>
    );
};

export default Community;
